import styled from 'styled-components/macro';

export const GdprWrapper = styled.div`
    font-size: 26px;
    margin-left: 0.5rem;
    margin-top: -0.1rem;
`;